var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"showBox",staticClass:"showBox",style:([_vm.width>0 ? {width:_vm.width+'px'} : '',_vm.height>0 ? {height:_vm.height+'px'} : ''])},[_c('div',{ref:"contentBox",staticClass:"contBox",style:({transform:_vm.transform})},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ebb7272","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/@kkmh/pays/src/components/viphalfscreen/comp/SetScale.vue
// module id = null
// module chunks = 